import { type VariantProps, cva } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from './cn';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium leading-none transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-primary/15 text-primary border border-primary/20',
        secondary: 'bg-secondary text-secondary-foreground border border-border',
        outline: 'border border-border text-foreground bg-transparent',
        destructive: 'bg-destructive/15 text-destructive border border-destructive/20',
        success: 'bg-emerald-500/15 text-emerald-500 border border-emerald-500/20',
        warning: 'bg-amber-500/15 text-amber-500 border border-amber-500/20',
        muted: 'bg-muted text-muted-foreground border border-border',
        brand: 'gradient-brand text-white border-0',
        violet: 'bg-violet-500/15 text-violet-500 border border-violet-500/20',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
